import { Loader2, RefreshCw } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { m } from '@/lib/paraglide/messages'

export function ActionButton({
    pending,
    icon: Icon,
    children,
    onClick,
    primary = false,
}: {
    pending: boolean
    icon: typeof RefreshCw
    children: ReactNode
    onClick: () => void
    /** The main action of its card, styled like the review dialog's trigger. */
    primary?: boolean
}) {
    return (
        <Button
            size="sm"
            variant={primary ? 'default' : 'outline'}
            onClick={onClick}
            disabled={pending}
        >
            {pending ? (
                <Loader2 className="size-3.5 animate-spin" />
            ) : (
                <Icon className="size-3.5" />
            )}
            {children}
        </Button>
    )
}

export function RefreshAction({
    pending,
    onClick,
}: {
    pending: boolean
    onClick: () => void
}) {
    return (
        <ActionButton pending={pending} icon={RefreshCw} onClick={onClick}>
            {m.einvoice_refresh()}
        </ActionButton>
    )
}
